export default __webpack_public_path__ + "static/media/factory__42.44519f18.jpg";